'use strict';

wbApp.controller('MyAccountCtrl', ['$scope', '$q', '$window', '$modal', 'tenantSettingSvc', 'userSvc', 'studentSvc',
    'referenceSourceSvc', 'duePaymentsSvc', 'paymentsSvc', '$timeout', 'messageBoxSvc', 'onlinePaymentsSvc', 'urlUtils', '$translate', '$http',
    'consentSvc', 'securitySvc',
function ($scope, $q, $window, $modal, tenantSettingSvc, userSvc, studentSvc,
    referenceSourceSvc, duePaymentsSvc, paymentsSvc, $timeout, messageBoxSvc, onlinePaymentsSvc, urlUtils, $translate, $http,
    consentSvc, securitySvc) {

    $scope.isInRegistrationMode = urlUtils.getQueryParams()['registration'] === "true";
    $scope.isDataLoaded = false;
    $scope.isBusy = true;    
    $scope.isAuthenticated = securitySvc.isAuthenticated();
    $scope.authCodeSent = false;
    $scope.passwordValidationRegEx = securitySvc.passwordValidationRegEx();

    $scope.tabs = [
        {
            title: 'TXT_TAB_USER_ACCOUNT',
            template: 'my-account/user-account-tab.html',
            name: 'user-account'
        }];
    
    if ($scope.isAuthenticated) {
        $scope.tabs.push(
            {
                title: 'TXT_TAB_STUDENTS',
                template: 'my-account/students-tab.html',
                name: 'students'
            },
            {
                title: 'TXT_TAB_CONTACT_DETAILS',
                template: 'my-account/contact-details-tab.html',
                name: 'contact-details'
            }            
        );
    }

    if (tenantSettingSvc.settings.enableDuePaymentsInClient && !$scope.isInRegistrationMode) {
        $scope.tabs.push({
            title: 'TXT_DUE_PAYMENTS',
            template: 'my-account/due-payments-tab.html',
            name: 'due-payments'
        });
    }

    if (!$scope.isInRegistrationMode) {
        $scope.tabs.push({
            title: 'TXT_TAB_MY_CONSENTS',
            template: 'my-account/my-consents.html',
            name: 'my-consents'
        });
    }

    function switchToCorrectTab() {
        let tabName = urlUtils.getQueryParams()['tabName'];
        if (!tabName) {
            tabName = $scope.isInRegistrationMode
                ? 'students'
                : 'user-account';
        }
        
        // find correct tab
        const tabIndexToActivate = _.findIndex($scope.tabs, {name: tabName});
        if (tabIndexToActivate !== -1 && $scope.tabs.activeTab !== tabIndexToActivate) {
            $scope.tabs.activeTab = tabIndexToActivate;
            return;
        }

        $scope.tabs.activeTab = 0;
        urlUtils.setUrlParam("tabName", $scope.tabs[$scope.tabs.activeTab].name);
    }

    switchToCorrectTab();

    $scope.isSaveBusy = false;    

    $scope.$watch('tabs.activeTab', function (newValue) {
        const tabName = $scope.tabs[newValue].name;
        urlUtils.setUrlParam("tabName", tabName);

        if (tabName === 'due-payments') {
            loadDuePayments();
        }

        if (tabName === 'my-consents') {
            loadMyConsents();
        }
    });

    $scope.tenantSetting = tenantSettingSvc.settings;
    $scope.hasSecondContact =
        ($scope.tenantSetting.mandatoryEmail2 < 2) ||
        ($scope.tenantSetting.mandatoryPhone2 < 2) ||
        ($scope.tenantSetting.mandatoryUserNationality2 < 2) ||
        ($scope.tenantSetting.mandatoryUserName2 < 2) ||
        ($scope.tenantSetting.mandatoryUserSurname2 < 2) ||
        ($scope.tenantSetting.mandatoryUserMiddleName2 < 2) ||
        ($scope.tenantSetting.mandatoryUserAddress2 < 2) ||
        ($scope.tenantSetting.mandatoryUserIdentityCardNumber2 < 2) ||
        ($scope.tenantSetting.mandatoryUserPersonalIDNumber2 < 2) ||
        ($scope.tenantSetting.mandatoryUserBirthday2 < 2);    

    $scope.hasReferrenceSource = false;

    referenceSourceSvc.getAllAsync().$promise
        .then(function (data) {
            $scope.hasReferrenceSource = data.length;
            loadData();
        });

    var paneCtrls = [];
    $scope.$on('$includeContentLoaded', function (event) {
        paneCtrls.push(event.targetScope.$$childTail);
        event.stopPropagation();
    });

    $scope.serverErrors = null;
    $scope.formErrors = {};

    $scope.areAllFormsValid = function () {
        return _.reduce(paneCtrls, function(sum, item) { 
            return !!item.form ? sum && item.form.$valid : sum;
        }, true);
    }

    $scope.isCurrentFormValid = function () {
        if ($scope.tabs.activeTab < paneCtrls.length) {
            var form = paneCtrls[$scope.tabs.activeTab].form;
            var isFormValid = !form || form.$valid;
            if (isFormValid) {
                $scope.formErrors = {};
                return true;
            } else {
                $scope.formErrors = form.$error;
            }

        }
        return false;
    }

    function setAllFormsPristine() {
        _.forEach(paneCtrls, function (item) {
            if (!!item.form) {
                item.form.$setPristine();
            }
        });
    }

    function swithToFirstInvalidForm() {
        var idx = _.findIndex(paneCtrls, function (item) { return !item.form.$valid; });
        if (idx !== -1) {
            $scope.tabs.activeTab = idx;
        }
    }

    //#region: User



    function isContactDetailsUnchanged(data) {
        return angular.equals(data, $scope.userOrig);
    }

    function isStudentsUnchanged(data) {
        return angular.equals(data, $scope.studentsOrig);
    }
    
    function createAccount() {
        if ($scope.isInRegistrationMode  && !$scope.isAuthenticated) {
            $scope.isSaveBusy = true;
            $scope.serverErrors = null;
            if ($scope.authCodeSent) {
                securitySvc.confirmEmailVerification($scope.user.email, $scope.user.otp).then(
                    function(success) {
                        securitySvc.signIn($scope.user.email, $scope.user.password).then(
                            function(siSuccess) {
                                $scope.isSaveBusy = false;
                                $window.location.reload();
                            },
                            function(siError) {
                                $scope.isSaveBusy = false;
                                $scope.serverErrors = { data: { title: securitySvc.gcpErrorCodeToText(siError) }};
                            }
                        );
                    },
                    function(error) {
                        $scope.isSaveBusy = false;
                        $scope.serverErrors = { data: { title: securitySvc.gcpErrorCodeToText(error) }};                        
                    }
                )
            }
            else {
                securitySvc.createUserWithEmailAndPassword($scope.user.email, $scope.user.password).then(
                    function(success) {
                        securitySvc.sendEmailVerificationAuthorizationCode($scope.user.email).then(
                            function(evSuccess) {
                                $scope.authCodeSent = true;
                                $scope.isSaveBusy = false;
                            },
                            function(evError) {
                                $scope.isSaveBusy = false;
                                $scope.serverErrors = { data: { title: securitySvc.gcpErrorCodeToText(evError) }};
                            }
                        );
                    },
                    function(error) {
                        $scope.serverErrors = { data: { title: securitySvc.gcpErrorCodeToText(error) }};
                        $scope.isSaveBusy = false;
                    }
                )
            }
        }
    }


    $scope.onSaveBtnClick = function (formCtrl, data) {

        if ($scope.isSaveBusy) {
            return;
        }

        if (!$scope.isCurrentFormValid()) {
            return;
        }

        if (!$scope.areAllFormsValid()) {
            swithToFirstInvalidForm();
            return;
        }
        
        if ($scope.isInRegistrationMode  && !$scope.isAuthenticated) {
            createAccount();
            return;
        }

        $scope.isSaveBusy = true;
        $scope.isBusy = true;
        $scope.serverErrors = null;
        var errorTabIndex = 0;

        var promises = [];

        function userSaveSuccess(data) {
            $scope.user = data;
            $scope.userOrig = angular.copy(data);
        }

        function userSaveError(errorResult) {
            $scope.serverErrors = errorResult;
            errorTabIndex = $scope.isInRegistrationMode 
                ? _.findIndex($scope.tabs, { name: 'contact-details' })
                : $scope.tabs.activeTab;
        }

        if (!isContactDetailsUnchanged($scope.user) || $scope.isInRegistrationMode) {
            // Save user
            promises.push(userSvc.update($scope.user, userSaveSuccess, userSaveError).$promise);
        }

        function studentsSaveSuccess(data) {
            $scope.students = data;
            $scope.studentsOrig = angular.copy(data);
        }

        function studentsSaveError(errorResult) {
            $scope.serverErrors = errorResult;
            errorTabIndex = _.findIndex($scope.tabs, { name: 'students' });
        }

        if (!isStudentsUnchanged($scope.students)) {
            promises.push(studentSvc.saveAll($scope.students, studentsSaveSuccess, studentsSaveError).$promise);
        }

        if (promises.length) {
            $q.all(promises).then(function (data) {

                $scope.isSaveBusy = false;
                $scope.isBusy = false;

                if ($scope.isInRegistrationMode) {
                    var queryParams = urlUtils.getQueryParams();
                    var returnUrl = urlUtils.getReturnUrl(queryParams);
                    if (returnUrl) {
                        //var params = urlUtils.getParamsStringWithoutReturnUrl(queryParams);
                        //if (!!params) {
                        //    $window.location.replace(returnUrl + '?' + params);
                        //} else {
                            $window.location.replace(returnUrl);
                       // }
                    } else {
                        $window.location.replace("/");
                    }
                } else {
                    setAllFormsPristine();

                    var queryParams = urlUtils.getQueryParams();
                    if (queryParams['returnOnSave'] == 'true') {
                        var returnUrl = urlUtils.getReturnUrl(queryParams);
                        $window.location.replace(returnUrl);
                    }
                }
            }, function (errorResult) {
                $scope.isSaveBusy = false;
                $scope.isBusy = false;
                $scope.tabs.activeTab = errorTabIndex;
            });
        } else {
            $scope.isSaveBusy = false;
            $scope.isBusy = false;
        }
    }


    $scope.onPrevBtnClick = function() {
        if ($scope.isPrevButtonVisible()) {
            $scope.tabs.activeTab = $scope.tabs.activeTab - 1;
        }
    }

    $scope.onNextBtnClick = function () {
        if ($scope.isCurrentFormValid()) {
            if ($scope.isNextButtonVisible()) {
                $scope.tabs.activeTab = $scope.tabs.activeTab + 1;
            }
        }
    }

    $scope.isNextButtonVisible = function () {
        return ($scope.tabs.activeTab < ($scope.tabs.length - 1));
    }

    $scope.isPrevButtonVisible = function () {
        return $scope.tabs.activeTab > 0;
    }    

    $scope.isSaveButtonVisible = function () {
        return ($scope.tabs.activeTab === ($scope.tabs.length - 1) && $scope.isInRegistrationMode) ||
            (!$scope.isInRegistrationMode &&
                $scope.tabs.activeTab !== _.findIndex($scope.tabs, { name: 'due-payments' }) &&
                $scope.tabs.activeTab !== _.findIndex($scope.tabs, { name: 'my-consents' })
            );
    }

    $scope.isSaveButtonDisabled = function () {
        if ($scope.isSaveBusy) {
            return true;
        }

        // if ($scope.isInRegistrationMode) {
        //     return $scope.isAuthenticated;
        // }
        
        return (isContactDetailsUnchanged($scope.user) && 
                 ($scope.tabs.activeTab === _.findIndex($scope.tabs, { name: 'user-account' }) || 
                  $scope.tabs.activeTab === _.findIndex($scope.tabs, { name: 'contact-details' }))
               ) ||
               (isStudentsUnchanged($scope.students) && $scope.tabs.activeTab === _.findIndex($scope.tabs, { name: 'students' }));
    }

    function loadData() {
        if (securitySvc.isAuthenticated()) {
            $scope.isBusy = true;
            $q.all([
                userSvc.getCurrentAsync().$promise,
                studentSvc.getCurrentAsync().$promise
            ]).then(function (data) {
                $scope.user = data[0];
                $scope.userOrig = angular.copy($scope.user);

                $scope.students = data[1];
                $scope.studentsOrig = angular.copy($scope.students);

                $scope.isBusy = false;
                $scope.isDataLoaded = true;
            }, function (errorResult) {
                $scope.isBusy = false;
            });
        } else {
            $scope.user = userSvc.createNew();
            $scope.userOrig = angular.copy($scope.user);
            $scope.students = [];
            $scope.isDataLoaded = true;
            $scope.isBusy = false;
        }
    }

   
    //#endregion

    //#region Students


    $scope.onAddStudent = function () {
        if ($scope.isDataLoaded) {
            $scope.students.push(studentSvc.createNew($scope.user));
        }
    }

    $scope.onDeleteStudent = function (student) {
        if ($scope.isDataLoaded) {
            var index = $scope.students.indexOf(student);
            $scope.students.splice(index, 1);
        }
    }

    //#endregion

    function loadMyConsents(success) {
        $timeout(function () {
            $scope.isBusy = true;
        }, 1);

        var currentUserID = securitySvc.loggedInUser().userID;

        var consents = consentSvc.getConsentsInfoForUser(currentUserID);
        consents.$promise.then(function (data) {
            $timeout(function () {
               
                var now = moment();
                var validConsents = [];
                var invalidConsesnts = [];
                _.forEach(data.consents, function (c) {
                    if (moment(c.validFrom).isSameOrBefore(now) &&
                        moment(c.validTo).isSameOrAfter(now)) {
                        validConsents.push(c);
                    } else {
                        invalidConsesnts.push(c);
                    }
                });

                data.consents = _.orderBy(validConsents, ['validFrom'], ['desc']);
                data.invalidConsents = invalidConsesnts;

                $scope.consentInfo = data;
                $scope.isBusy = false;

                if (success) {
                    success($scope.consentInfo);
                }
            }, 100);
        }, function () {
            $timeout(function () {
                $scope.isBusy = false;
            }, 100);
        });
    }

    $scope.approveConsent = function (consent) {

        if ($scope.isSaveBusy) {
            return;
        }

        $scope.isSaveBusy = true;

        consentSvc.approveConsent(
            consent,
            function () {
                // Success
                $scope.isSaveBusy = false;

                loadMyConsents();
            }, function () {
                $scope.isSaveBusy = false;
            });
    }

    $scope.rejectConsent = function (consent) {

        if ($scope.isSaveBusy) {
            return;
        }

        $scope.isSaveBusy = true;

        consentSvc.rejectConsent(
            consent,
            function () {
                // Success
                $scope.isSaveBusy = false;

                loadMyConsents();
            }, function () {
                $scope.isSaveBusy = false;
            });
    }


    $scope.duePayments = [];

    function loadDuePayments() {
        $timeout(function () {
            $scope.isBusy = true;
        }, 1);
        
        $scope.duePayments = duePaymentsSvc.getAllForCurrentUser(!$scope.tenantSetting.showOverpaymentsInClientDuePayments);
        $scope.duePayments.$promise.then(function (data) {
            $timeout(function () {
                $scope.isBusy = false;
            }, 100);
        }, function () {
            $timeout(function () {
                $scope.isBusy = false;
            }, 100);
        });
    }

    function startOnlinePayment(invoiceID, price) 
    {
        return onlinePaymentsSvc.startOnlinePayment([invoiceID], price);
    }

    $scope.onPrintInvoice = function(invoiceID) {
        $window.open('/Admin/Report/Invoice?ReportID=' + invoiceID + '&ReportIDType=1',
            '_blank', 'width=1000,height=500,toolbar=no,resizable=yes,location=no,directories=no,status=no,menubar=no,copyhistory=no');
    }

    $scope.onlinePayment = function (invoiceID, price) {
        if (price > 0) {
            messageBoxSvc.showMessageDlg({
                title: 'TXT_TITLE_CONFIRM_ONLINE_PAYMENT',
                message: '<i class="fa fa-3x fa-credit-card text-success pull-right" aria-hidden="true"></i>' +
                    $translate.instant('TXT_CONFIRM_CONFIRM_START_ONLINE_PAYMENT'),
                buttons: [{
                    text: 'TXT_BTN_CANCEL'
                }, {
                    text: 'TXT_BTN_YES',
                    callback: function () { return startOnlinePayment(invoiceID, price).$promise; }
                }]
            });
        }
    }

    $scope.showPayments = function (duePayment) {
        $q.all([
            paymentsSvc.getAllForUserAsync(duePayment.parentID).$promise,
            modalPromise.$promise]).then(function (data) {
                modalPromise.$scope.model = duePayment;
                modalPromise.$scope.payments = _.filter(data[0], function(o) 
                {
                    if (duePayment.typeID > 3) // ? Can this even happen, this seems to have only 
                    {
                        return duePayment.invoiceID == o.invoiceID;
                    }
                    return duePayment.typeReferenceID == o.typeReferenceID &&
                           duePayment.typeReference2ID == o.typeReference2ID;                    
                });
                modalPromise.show();
            });
    }

    var modalPromise = $modal({
        templateUrl: 'my-account/due-payments-detail.html',
        show: false,
        backdrop: true,
        scope: $scope.$new()
    });

    shouldDisplayOnlinePaymentResult();

    function shouldDisplayOnlinePaymentResult() 
    {
        var onlinePaymentIDStr = urlUtils.getQueryParams()['onlinePaymentID'];
        if (!!onlinePaymentIDStr) {
            var onlinePaymentID = Number(onlinePaymentIDStr);

            onlinePaymentsSvc.getTransactionState(onlinePaymentID).$promise.then(
                function (data) {
                    messageBoxSvc.showMessageDlg({
                        title: 'TXT_PAYMENT_RESULT',
                        message: onlinePaymentsSvc.getOnlinePaymentResultMessage(data),
                        buttons: [{
                            text: 'TXT_BTN_OK',
                            callback: function () {
                                urlUtils.removeUrlParam('onlinePaymentID');
                                if (data.state === 3) {
                                    loadDuePayments();
                                }
                            }
                        }]
                    });
                });
        }
    }

    $scope.typeAheadAddress = [];

    $scope.allMatch = function () {
        return true;
    };

    $scope.getAddress = function (viewValue) {
        if (viewValue) {
            var params = {
                address: viewValue,
                language: 'cs',
                region: 'cz',
                bounds: '48.270777,12.172380|51.246709,19.922157', // Czech republic bounds
                key: 'AIzaSyDdpRFWJaEcASaUgQxTdi8i42aaCaKfS0A'
            };
            return $http.get('https://maps.googleapis.com/maps/api/geocode/json', { params: params })
                .then(function (res) {
                    $scope.typeAheadAddress.length = 0;                   
                    $scope.typeAheadAddress.push.apply($scope.typeAheadAddress, res.data.results);
                });
        } 
    };

    var amortizationScheduleDlg = $modal({
        templateUrl: '/partials/book-course-amortization-schedule.html',
        show: false,
        backdrop: true,
        scope: $scope
    });

    $scope.showAmortizationSchedule = function (model) {
        amortizationScheduleDlg.$promise.then(function () {
            amortizationScheduleDlg.$scope.invoiceID = model.invoiceID;
            amortizationScheduleDlg.$scope.model = { studentFullName: model.studentFullName };
            amortizationScheduleDlg.show();
        });
    }

}]);
